import seeds from '../assets/seeds.json'

export function formatSeedTypeName(seedType) {
  const seed = seeds.find(seed => seed.id === seedType)
  return seed?.name
}